import { e as i } from "../class-map-Di-Oe7s4.js";
import { u as p, s as v } from "../static-CPcCYSrK.js";
import { c as u } from "../lit-element-8JrrHldg.js";
import "./pwc-icon.js";
import "../cross-De9fASU6.js";
import { P as f } from "../pwc-element-CZs0VuUW.js";
import { p as w } from "../pwcProperty-CTLG9yrF.js";
var P = Object.defineProperty, g = Object.getOwnPropertyDescriptor, m = (e, t, c, r) => {
  for (var o = r > 1 ? void 0 : r ? g(t, c) : t, l = e.length - 1, a; l >= 0; l--)
    (a = e[l]) && (o = (r ? a(t, c, o) : a(o)) || o);
  return r && o && P(t, c, o), o;
};
const n = "pwc-select-tag";
let s = class extends f {
  constructor() {
    super(...arguments), this.slotControlled = [];
  }
  handleRemoveClick() {
    this.emit("remove", {});
  }
  render() {
    const { removable: e } = this, t = v(e ? "button" : "span");
    return p`
      <${t}
        type=${e ? "button" : ""}
        class=${i({
      PwcSelectTag: !0,
      "PwcSelectTag--removable": e
    })}
        @click=${() => e ? this.handleRemoveClick() : null}
      >
        <p-slot .host=${this}></p-slot>

        ${e ? p`<div class="PwcSelectTag__icon">
                <pwc-icon icon="cross"></pwc-icon>
              </div>` : ""}
      </${t}>
    `;
  }
};
s.tagName = n;
m([
  w({ type: Boolean, default: !1 })
], s.prototype, "removable", 2);
s = m([
  u(n)
], s);
export {
  s as PwcSelectTag
};
